module.exports = ""


//////////////////
// WEBPACK FOOTER
// /Users/usuario/Desktop/duran/duran-web/src/app/components/cabecera.component.html
// module id = ../../../../../src/app/components/cabecera.component.html
// module chunks = main